<ng-container *ngIf="specials && specials.length > 0">
  <lib-section-header
    *ngIf="title && titleIcon"
    [title]="title"
    [titleIcon]="titleIcon"
    [titleSize]="titleSize"
    [colorScheme]="colorScheme">
  </lib-section-header>
  <div
    *ngIf="specials"
    class="specials-container"
    [class.d-none]="specials.length >= 4">
    <app-special-card
      *ngFor="let special of specials"
      [special]="special">
    </app-special-card>
  </div>
  <lib-slider
    class="specials-slider"
    *ngIf="specials"
    [class.d-none]="specials.length < 4"
  >
    <lib-slider-item *ngFor="let special of specials">
      <app-special-card
        class="special"
        [special]="special">
      </app-special-card>
    </lib-slider-item>
  </lib-slider>
</ng-container>
